// directives/inject-attributes.ts
import { nothing } from "lit";
import { AsyncDirective } from "lit/async-directive.js";
import { directive } from "lit/directive.js";
var GLOBAL_BLACKLIST = ["style", "class", "id"];
var InjectAttributesDirective = class extends AsyncDirective {
  constructor(partInfo) {
    super(partInfo);
    this._blacklist = [];
    this.mo = new MutationObserver((attrChanges) => {
      for (const change of attrChanges) {
        if (this._element && !this._blacklist.concat(GLOBAL_BLACKLIST).includes(change.attributeName))
          this._element.setAttribute(change.attributeName, this._wrappedElement.getAttribute(change.attributeName));
      }
    });
    if (!partInfo.element)
      throw new Error("inject attributes needs to be instanceof ElementPart");
    this._element = partInfo.element || partInfo;
  }
  render(wrappedElement, blacklist = []) {
    this._wrappedElement = wrappedElement;
    this._blacklist = blacklist;
    this.mo.observe(this._wrappedElement, { attributes: true });
    for (const attrName of this._wrappedElement.getAttributeNames())
      if (!blacklist.concat(GLOBAL_BLACKLIST).includes(attrName))
        this._element.setAttribute(attrName, this._wrappedElement.getAttribute(attrName));
    return nothing;
  }
  disconnected() {
    this.mo.disconnect();
  }
  reconnected() {
    this.mo.observe(this._wrappedElement, { attributes: true });
  }
};
var injectAttributesOf = directive(InjectAttributesDirective);
export {
  injectAttributesOf
};
